import styled, { css } from 'styled-components';
import { animated } from 'react-spring';
import { color, typography } from 'styles/settings';
import { Row as _Row } from 'components/layout';
import { ReactComponent as Minus } from 'styles/icons/minus.svg';
import { ReactComponent as Plus } from 'styles/icons/plus.svg';
import { ReactComponent as FitToScreen } from 'styles/icons/fit-to-screen.svg';
import { normalize } from 'utils/styles';
import { H4 } from 'components/typography';

const iconStyles = css`
  align-items: center;
  cursor: pointer;
  color: ${color.brand.blueDark};
  display: flex;
  height: ${typography.size.rg};
  width: ${typography.size.rg};
  padding: ${normalize('5px')};
`;

export const Icon = styled.img`
  ${iconStyles};
`;

export const StyledZoomMenu = styled(animated.div)`
  background-color: ${color.neutral.white};
  flex: 1;
  flex-direction: row;
  z-index: 2;
`;

export const Row = styled(_Row)`
  justify-content: space-between;
  padding: 12px 16px;
  align-items: center;
`;

export const MinusIcon = styled(Minus)`
  ${iconStyles}
  :hover {
    color: ${color.brand.gold};
  }
  :active {
    color: ${color.brand.blueDark};
  }
`;

export const PlusIcon = styled(Plus)`
  ${iconStyles}
  :hover {
    color: ${color.brand.gold};
  }
  :active {
    color: ${color.brand.blueDark};
  }
`;

export const FitToScreenIcon = styled(FitToScreen)`
  align-items: center;
  cursor: pointer;
  color: ${color.brand.blueDark};
  display: flex;
  height: ${typography.size.lg};
  width: ${typography.size.lg};

  :hover {
    color: ${color.brand.gold};
  }
  :active {
    color: ${color.brand.blueDark};
  }
`;

export const Separator = styled.div`
  background-color: ${color.ui.backgroundGray};
  height: ${normalize('26px')};
  width: ${normalize('1px')};
`;

export const ZoomPercentage = styled(H4)`
  cursor: pointer;
  width: ${normalize('45px')};
  font-size: ${typography.size.md};
  :hover {
    color: ${color.brand.gold};
  }
  :active {
    color: ${color.brand.blueDark};
  }
`;
